const programs = {
  credito: 'CRÉDITO',
  debito: 'Banking',
  'debito zero-balance': 'Banking',
  'credito zero-balance': 'Credit',
};

export default programs;
